module.exports = __webpack_public_path__ + "static/media/meta-star.169e5327.svg";